import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background with hexagonal pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 border-2 border-toxic-green rotate-45 transform"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border-2 border-toxic-green rotate-12 transform"></div>
        <div className="absolute bottom-20 left-1/3 w-40 h-40 border-2 border-toxic-green rotate-45 transform"></div>
        <div className="absolute bottom-40 right-1/4 w-28 h-28 border-2 border-toxic-green rotate-12 transform"></div>
      </div>

      {/* Background image */}
      <div className="absolute inset-0 bg-gradient-to-br from-dark-bg via-dark-card to-dark-bg opacity-90">
        <img 
          src="/images/mathias-reding-IoBWWNX8XtA-unsplash.webp" 
          alt="" 
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-toxic-green/5 via-transparent to-toxic-green/5"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="inline-block mb-4">
          <Sparkles className="w-8 h-8 text-toxic-green animate-pulse" />
        </div>
        <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-white via-toxic-green to-white bg-clip-text text-transparent" itemProp="headline">
          Votre Portail vers les Meilleurs Sites de Paris
        </h1>
        <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto" itemProp="description">
          Comparez les offres, découvrez les bonus exclusifs et trouvez la plateforme de paris qui correspond à vos attentes. Nous connectons les passionnés aux meilleures opportunités.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mb-8">
          <a
            href="#offres"
            data-discover="true"
            className="inline-flex items-center justify-center px-6 py-3 bg-toxic-green text-dark-bg font-semibold rounded-lg hover:bg-opacity-80 transition-all transform hover:scale-105 shadow-lg shadow-toxic-green/50"
          >
            Offres
          </a>
          <a
            href="#a-propos"
            data-discover="true"
            className="inline-flex items-center justify-center px-6 py-3 border-2 border-toxic-green text-toxic-green font-semibold rounded-lg hover:bg-toxic-green hover:text-dark-bg transition-all"
          >
            À Propos
          </a>
          <a
            href="#guides"
            data-discover="true"
            className="inline-flex items-center justify-center px-6 py-3 border-2 border-toxic-green text-toxic-green font-semibold rounded-lg hover:bg-toxic-green hover:text-dark-bg transition-all"
          >
            Guides
          </a>
          <a
            href="#faq"
            data-discover="true"
            className="inline-flex items-center justify-center px-6 py-3 border-2 border-toxic-green text-toxic-green font-semibold rounded-lg hover:bg-toxic-green hover:text-dark-bg transition-all"
          >
            FAQ
          </a>
          <a
            href="#actualites"
            data-discover="true"
            className="inline-flex items-center justify-center px-6 py-3 border-2 border-toxic-green text-toxic-green font-semibold rounded-lg hover:bg-toxic-green hover:text-dark-bg transition-all"
          >
            Actualités
          </a>
          <a
            href="#contact"
            data-discover="true"
            className="inline-flex items-center justify-center px-6 py-3 border-2 border-toxic-green text-toxic-green font-semibold rounded-lg hover:bg-toxic-green hover:text-dark-bg transition-all"
          >
            Contact
          </a>
        </div>
        
      </div>
    </section>
  );
};

export default Hero;

